import { NgModule } from '@angular/core';
import { SettingListComponent } from './setting-list/setting-list.component';
import { SettingEditComponent } from './setting-edit/setting-edit.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { ExcelModule } from '@progress/kendo-angular-grid';
import { ListBoxModule } from '@progress/kendo-angular-listbox';

@NgModule({
  declarations: [
    SettingListComponent,
    SettingEditComponent
  ],
  imports: [
    SharedModule,
    ExcelModule,
    ListBoxModule
  ]
})
export class SettingModule { }
